import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import { getTooltipData } from 'Components/UI/MeetingInformation/tooltipData';
import { useDebugState } from 'Context/DebugContext';

const styles = theme => ({
  root: {
    display: 'inline-block',
    padding: theme.spacing(1),
    cursor: 'pointer',
  },
  tooltip: {
    backgroundColor: fade(theme.palette.grey[900], 1),
    maxWidth: theme.dimensions.md,
  },
  content: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(1),
  },
  columns: {
    display: 'flex',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'start',
    minWidth: 0,
  },
  columnAlignEnd: {
    textAlign: 'end',
    flexShrink: 0,
  },
  label: {
    paddingRight: theme.spacing(1),
  },
  value: {
    flexGrow: 1,
    width: '100%',
  },
  helpIcon: {
    paddingLeft: theme.spacing(1),
  },
});

const MeetingInformationTooltip = ({
  className,
  classes,
  householdResource,
  meetingResource,
}) => {
  const tooltipData = getTooltipData(meetingResource, householdResource);
  const debugState = useDebugState();

  if (!debugState.showMeetingInformation) {
    return null;
  }

  return (
    <Tooltip
      classes={{
        tooltip: classes.tooltip,
      }}
      title={
        <div className={classes.content}>
          <Typography className={classes.title} variant="h6">
            {'Meeting Information'}
          </Typography>
          <div className={classes.columns}>
            <div className={classNames(classes.column, classes.columnAlignEnd)}>
              {tooltipData.map(item => (
                <Typography
                  className={classes.label}
                  key={item.prompt}
                  noWrap
                >
                  {item.prompt}
                </Typography>
              ))}
            </div>
            <div className={classes.column}>
              {tooltipData.map(item => (
                <Typography
                  className={classes.value}
                  key={item.prompt}
                  noWrap
                >
                  {item.value}
                </Typography>
              ))}
            </div>
          </div>
        </div>
      }
    >
      <Typography
        className={classNames(classes.root, className)}
        color="accentBlue"
        component="div"
        noWrap
      >
        {'Meeting Information'}
        <HelpOutlineIcon
          className={classes.helpIcon}
          fontSize="medium"
        />
      </Typography>
    </Tooltip>
  );
};

MeetingInformationTooltip.defaultProps = {
  className: '',
};

MeetingInformationTooltip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(MeetingInformationTooltip);
